import { useEffect } from "react";

const Redirector = () => {
  const handleRedirect = () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const share = urlParams.get("share"); // game view sharing
      const invite = urlParams.get("invite"); // referral code
      const user = urlParams.get("user"); // profile link
      const stats = urlParams.get("stats"); // statistics screen + page view link
      const gift = urlParams.get("gift"); // gift link auto enter
      const event = urlParams.get("event"); // group challenge event join code
      const community = urlParams.get("community"); // community join code
      console.log("Redirecting!")

      // Trigger deep link on user interaction
      if (share) {
        const deepLink = `parallelpoker://replay?share=${encodeURIComponent(share)}&date=${Date.now()}`;
        window.location.href = deepLink;
      } else if (invite) {
        const deepLink = `parallelpoker://refer?invite=${encodeURIComponent(invite)}&date=${Date.now()}`;
        window.location.href = deepLink;
      } else if (user) {
        // Can have spaces:
        const deepLink = `parallelpoker://profile?user=${encodeURIComponent(user)}&date=${Date.now()}`;
        window.location.href = deepLink;
      } else if (stats) {
        const deepLink = `parallelpoker://statistics?stats=${encodeURIComponent(stats)}&date=${Date.now()}`;
        window.location.href = deepLink;
      } else if (gift) {
        const deepLink = `parallelpoker://giftCode?gift=${encodeURIComponent(gift)}&date=${Date.now()}`;
        window.location.href = deepLink;
      } else if (event) {
        const deepLink = `parallelpoker://event?event=${encodeURIComponent(event)}&date=${Date.now()}`;
        window.location.href = deepLink;
      } else if (community) {
        const deepLink = `parallelpoker://community?community=${encodeURIComponent(community)}&date=${Date.now()}`;
        window.location.href = deepLink;
      } else {
        window.location.href = "https://parallelpoker.com/";
      }
    } catch (err) {
      alert(err)
    }
  };
  useEffect(() => {
    handleRedirect()
  }, []);

  return (
    <div>
      <h1>Redirecting...</h1>
      <h2>Please open this link in a browser on iOS or Android.</h2>
      <button onClick={handleRedirect}>
        Redirect to App
      </button>
    </div>
  );
};

export default Redirector;
